import React from 'react'
import HeroSection from '../HeroSection'

function AboutMe() {
  return (
    <>
    <HeroSection/>
    </>
    
  )
}

export default AboutMe